module.exports = __webpack_public_path__ + "img/8.9668ebaa.png";